<template>
  <b-row align-v="start" class="pb-3">
    <b-col sm="3" align="center" class="label-col pb-3 pt-2">
      <label :label-for="id">{{titleText}}</label>
    </b-col>
    <b-col sm="9">
      <b-row>
        <b-col :sm="parseInt(dropdownColSize)">
          <b-form-select
              :id="id"
              type="dropdown"
              v-model="inputValue"
              :options="options"
              :value="0"
              :state="isValid"
          >
            <template slot="first">
              <option :value="null" disabled>-- Please select an option --</option>
            </template>
          </b-form-select>
        </b-col>
      </b-row>
      <b-form-invalid-feedback
          :id="id + 'Invalid'"
          v-if="!(validation===undefined)"
          align="left">
        <font-awesome-icon :icon="['far','exclamation-triangle']"/>{{validationText}}
        Test
      </b-form-invalid-feedback>
      <b-row>
        <b-col>
          <b-form-text :label-for="id">{{description}}</b-form-text>
        </b-col>
      </b-row>
    </b-col>
  </b-row>

</template>

<script>

  import { getValidationMessages } from './../../../../js/validation/validationMessages.js'
  import {mapMutations} from 'vuex';

  export default {
    name: "RxDropdown",

    props: {
      value: {
      },
      options:  {
        type: Array,
        required: true
      },
      description: {
        type: String,
        required: false,
      },
      titleText: {
        type: String,
        required: true
      },
      id:{
        type: String,
        required: true
      },
      dropdownColSize: {
        type: Number,
        default: 12
      },
      validation: {
        type: Object,
        required: false
      }
    },
    computed: {
      inputValue: {
        // inputValue's getter and setter allow v-model to chain down to subcomponents with
        // two-way binding intact.
        get() {
          return this.value
        },
        set(v) {
          if (this.validation !== undefined){
            this.validation.$touch()
          }
          this.$emit('input',v)
        }
      },
      isValid() {
        if (this.validation !== undefined && this.validation.$dirty){
          // Show valid when there is an existing valid selection on navigation to this component
          return !this.validation.$error ? 'valid' : 'invalid'
        }
      },
      validationText(){
        if (this.validation !== undefined) {
          return getValidationMessages(this.validation)
        }
      }
    },
    methods: {
      ...mapMutations('rx',
      ['setPageDirty'])
    }
  }
</script>

<style scoped>

  label {
    font-size: 1.2rem;
  }


</style>